import proyecto from "../../api/Proyecto";

export const getServicios = async ({ q = "", activos = "1", completo } = {}) => {
  const response = await proyecto.get("/servicios", { params: { q, activos, completo } });
  return response.data;
};

export const crearServicio = async (servicio) => {
  const response = await proyecto.post("/servicios", servicio);
  return response.data;
};

export const actualizarServicio = async (id, servicio) => {
  const response = await proyecto.put(`/servicios/${id}`, servicio);
  return response.data;
};

export const desactivarServicio = async (id) => {
  const response = await proyecto.delete(`/servicios/${id}`);
  return response.data;
};

